<template>
  <div class="page-header" :class="{ transparent: mode === 'transparent' }">
    <div class="navbar">
      <div class="logo">
        <img
          style="height: 26px; cursor: pointer"
          :src="logoUrl"
          @click="toHome"
        />
        <div
          class="version-tag"
          :class="{ transparent: mode === 'transparent' }"
        >
          预览版
        </div>
      </div>
      <div class="flex row-right tab-switch-box">
        <a-dropdown :trigger="['hover']" placement="bottomRight">
          <div
            class="tab-item"
            :style="{ color: mode === 'transparent' ? '#fff' : '#333' }"
          >
            投标宝箱
            <div class="label">推荐</div>
          </div>
          <a-menu slot="overlay" style="left: 30px; top: 10px">
            <a-menu-item @click.native="goPage('TreasureChestConsultant')">
              <div class="dropdown-item">投标顾问</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestNotice')">
              <div class="dropdown-item">全网商机</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestSubscription')">
              <div class="dropdown-item">标讯订阅</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestCompetitor')">
              <div class="dropdown-item">竞争对手分析</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestPurchaser')">
              <div class="dropdown-item">采购单位分析</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestCustomData')">
              <div class="dropdown-item">数据定制导出</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestFollow')">
              <div class="dropdown-item">我的关注</div>
            </a-menu-item>
            <a-menu-item @click.native="goPage('TreasureChestBond')">
              <div class="dropdown-item">会员保证金担保</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <tab-switch
          v-model="activeIndex"
          :tab-list="navbarList"
          :normal-color="mode === 'transparent' ? '#fff' : '#333'"
          @changeTab="handleNavSelect"
        />
        <a-dropdown
          v-if="isLogin"
          class="m-l-40"
          :trigger="['click']"
          placement="bottomRight"
        >
          <el-avatar style="cursor: pointer" :size="32" :src="avatarUrl" />
          <a-menu slot="overlay">
            <a-menu-item @click.native="toPersonalCenter()">
              <div class="dropdown-item dropdown-item--main text-ellipsis">
                {{ userInfo.nickname || '个人中心' }}
              </div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item @click.native="toPersonalCenter('vip-home')">
              <div class="dropdown-item">会员中心</div>
            </a-menu-item>
            <a-menu-item @click.native="toPersonalCenter('portrait-record')">
              <div class="dropdown-item">分析记录</div>
            </a-menu-item>
            <a-menu-item @click.native="toPersonalCenter('custom-data')">
              <div class="dropdown-item">数据导出记录</div>
            </a-menu-item>
            <a-menu-item @click.native="logout">
              <div class="dropdown-item">退出登录</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div v-else class="login-button" @click="toLogin">
          <a-icon class="m-r-6" type="user" />
          <span>登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import TabSwitch from '@/components/common/TabSwitch'
// 路由
import { routes, useRoute } from '@/router'
// 状态
import { mapState } from 'vuex'
// 工具
import { toLogin } from '@/utils/common'
// 接口
import { getFileUrlByFileIdApi } from '@/api/file'
import alifeLogger from '@/plugins/alife-logger'

export default {
  name: 'PageHeader',

  components: { TabSwitch },

  props: {
    // 模式，可选值：default, transparent
    mode: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'transparent'].indexOf(value) !== -1
    }
  },

  data() {
    return {
      timer: null,
      activeIndex: '',
      barOffset: 0,
      navbarList: [],
      avatarUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    }
  },

  computed: {
    ...mapState('user', ['isLogin', 'userInfo', 'isPortraitBtnShow']),

    logoUrl() {
      return this.mode === 'transparent'
        ? require('@/assets/images/logo-white.png')
        : require('@/assets/images/logo.png')
    }
  },

  watch: {
    $route(val) {
      const index = this.navbarList.findIndex((item) =>
        val.path.includes(item.route.path)
      )
      this.activeIndex = index
    },
    isPortraitBtnShow: {
      handler(val) {
        if (this.isLogin) {
          this.filterNavBar()
        }
      },
      immediate: true
    }
  },

  async created() {
    await this.$store
      .dispatch('user/checkLogin')
      .then(async () => {
        await this.$store.dispatch('user/getUserBasicInfo').then((res) => {
          this.getAvatarUrl(res.data.userInfo.face)
        })
        await this.$store.dispatch('user/getUserVipInfo')
        await this.$store.dispatch('user/getBiddogGray')
      })
      .catch((err) => {})
    alifeLogger()
    this.filterNavBar()
    this.setIndexByRoute()
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  methods: {
    goPage(name) {
      this.$router.push(
        {
          name: name
        },
        () => {}
      )
    },

    setIndexByRoute() {
      const currentRoute = useRoute()
      const index = this.navbarList.findIndex((item) =>
        currentRoute.path.includes(item.route.path)
      )
      this.activeIndex = index
    },

    handleNavSelect(index) {
      if (index < 0 || index === '') return
      const nav = this.navbarList[index].route
      const currentPath = useRoute()
      if (currentPath.path === nav.path) return
      this.$router.push({
        path: nav.path
      })
    },

    toLogin,

    logout() {
      this.timer = setTimeout((_) => {
        sessionStorage.setItem('popupShow', 'close')
      }, 500)
      this.$store.dispatch('user/logout')
    },

    /**
     * 获取头像链接
     */
    getAvatarUrl(fileId) {
      if (!fileId) {
        this.avatarUrl =
          'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        return
      }

      getFileUrlByFileIdApi({ attachmentId: fileId })
        .then((res) => {
          this.avatarUrl =
            res.data?.presignedUrl ||
            'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        })
        .catch((err) => {
          console.error('获取头像链接失败', err)
          if (err?.message) this.$message.error(err?.message)
        })
    },

    /**
     * 前往首页
     */
    toHome() {
      const currentRoute = useRoute()
      if (currentRoute.name === 'Home') return

      this.$router.push({
        name: 'Home'
      })
    },

    /**
     * 前往云采购相应模块
     */
    toPlatform(path) {
      const url = process.env.VUE_APP_DOMAIN + path
      window.open(url, '_blank')
    },

    /**
     * 前往个人中心的相应模块
     */
    toPersonalCenter(moduleName) {
      if (moduleName) {
        window.location.href = `${
          process.env.VUE_APP_PASSPORT_URL
        }/personal-center/value-added-services/${moduleName}?returnUrl=${encodeURIComponent(
          window.location.href
        )}`
      } else {
        window.location.href = `${
          process.env.VUE_APP_PASSPORT_URL
        }/personal-center?returnUrl=${encodeURIComponent(window.location.href)}`
      }
    },
    // 过滤header菜单
    filterNavBar() {
      this.navbarList = (routes || [])
        .filter((item) => {
          // 未登录及灰度未包含该用户的情况下不展示画像菜单
          if (!this.isPortraitBtnShow) {
            return (
              item.meta?.inNavbar &&
              item.name != 'CompetitorAnalysisList' &&
              item.name != 'PurchaserAnalysisList'
            )
          } else {
            return item.meta?.inNavbar
          }
        })
        .map((item) => {
          return {
            label: item.meta.title,
            route: item
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  position: fixed;
  width: 100%;
  min-width: $body-width;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid $border-color;
  background-color: $white-color;

  .navbar {
    width: $body-width;
    height: $header-height;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login-button {
      color: $text-color;
      margin-left: 40px;
      cursor: pointer;
    }
  }

  &.transparent {
    border-bottom: 1px solid rgba(234, 234, 234, 0.25);
    background-color: rgba(255, 255, 255, 0.001);
    .login-button {
      color: $white-color;
    }
  }
}

.logo {
  display: flex;
  align-items: center;

  .version-tag {
    padding: 4px 8px;
    border-radius: 2px;
    font-size: 12px;
    margin-left: 10px;
    background-color: $primary-sixth-color;
    color: $white-color;

    &.transparent {
      background-color: #cdddfd;
      color: #0050b3;
    }
  }
}
.tab-switch-box {
  .tab-item {
    margin-right: 40px;
    cursor: pointer;
    position: relative;
    .label {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: -15px;
      right: -32px;
      padding: 2px 3px;
      color: $white-color;
      font-size: 11px;
      background: $danger-color;
      border-radius: 10px 10px 10px 0px;
    }
  }
}
.dropdown-item {
  font-size: 14px;
  color: $text-second-color;
  max-width: calc(160px - 32px);

  &--main {
    color: $text-color;
    @include text-bold;
  }
}

::v-deep .ant-dropdown-menu {
  padding: 8px 0;
}

::v-deep .ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
  padding: 10px 16px;
  line-height: 1.4;
}
</style>
